export function createProduction(data, selectedWorkOrders) {
    return new Promise((resolve, reject) => {
        let { createProductionRequest, createProductionError, createProductionResult } = this.props

        // delete data.creationDate;
        // delete data.updateDate;

        this.doAction(
            this.WEB_REQUEST_URL + 'create_production',
            this.createBundle(
                'create_production',
                { production: data, selectedWorkOrders },
                this.POST,
                createProductionRequest,
                (result) => {
                    createProductionResult(result)
                    resolve(result)
                },
                (error) => {
                    createProductionError(error)
                    reject(error)
                }
            )
        )
    })
}
